export const questions: Array<[string, string]> = [
  [
    'Professional level?',
    'Hydrogen engineers, industrial technicians, energy professionals, renewable energy specialists, fuel cell professionals worldwide.',
  ],
  [
    'Content depth?',
    'From hydrogen fundamentals through advanced electrolysis, fuel cells, storage infrastructure, industrial applications, safety, and future technologies. Scales from foundational to professional expertise.',
  ],
  ['International?', 'Yes. Universal hydrogen technology principles with guidance for regional energy codes and standards.'],
  ['Editable?', 'Yes. Professional-grade PDFs for reference and technical documentation.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  [
    'What makes it different?',
    'Complete system: 6 coherent volumes, 5 exclusive bonuses, technical dictionary, hydrogen vs battery comparison, 16 misconceptions clarified, project economics guide, 12 industry scenarios. Everything designed so you never struggle with technical understanding again.',
  ],
  ['Not satisfied?', '7-day refund. 100% money back, no questions.'],
];
